import { DeviceInfoModel, LogEntry, DeviceLogLevel, DeviceLogInput } from '../../Models/Logging/Logging';
import { Injectable } from '@angular/core';
import { v4 } from '../../Helpers/v4';
import { environment } from 'Public_old/src/environments/environment';

@Injectable()
export class SpaLogger {
	entries: Array<LogEntry> = [];
	deviceInfoModel: DeviceInfoModel = null;
	myDeviceId: string = localStorage.getItem('X-DeviceId');
	myVisitId: string = null;
	outgoingEntries: Array<Array<LogEntry>> = [];

	/**
	 * @param logLevel - 1=Normal, 2=Dno, 3=Debug
	 */
	private _logLevel: number = 1;

	get logLevel(): number {
		return window['overrideLogLevel'] || this._logLevel;
	}

	set logLevel(value: number) {
		this._logLevel = value;
	}

	constructor() {
		this.myVisitId = v4();

		if (this.myDeviceId === null) {
			this.myDeviceId = v4();
			localStorage.setItem('X-DeviceId', this.myDeviceId);
		}

		this.deviceInfoModel = {
			AppBuild: null,
			AppVersion: null,
			Browser: platform.name,
			BrowserVersion: platform.version,
			AppName: null,
			DeviceName: null,
			Os: platform.os.family,
			OsVersion: platform.os.version,
			Platform: 'JavaScript',
		};

		window.setInterval(this.postEntries, 30 * 1000);
	}

	log(logLevel: DeviceLogLevel, tags: Array<string>, text: string, data: Object = null, stackTrace: string = null) {
		const levelColor = logLevel === 'Debug' ? 'blue' : logLevel === 'Error' ? 'red' : 'grey';

		if (this.logLevel === 3) {
			console.log(
				`%c-${logLevel.toUpperCase()}- %c[${tags.join('][')}] %c${text}`,
				`color: ${levelColor};font-weight:bold;font-size:14px;`,
				'font-weight:bold;color: #008296;',
				'color: #59b6c4;',
				data,
			);
		}

		// this.entries.push({
		// 	Timestamp: new Date(),
		// 	Tags: tags,
		// 	Text: text,
		// 	Data: data,
		// 	StackTrace: stackTrace,
		// 	LogLevel: logLevel,
		// });
	}

	logInstant(logLevel: DeviceLogLevel, tags: Array<string>, text: string, data: Object = null, stackTrace: string = null) {
		this.entries.push({
			Timestamp: new Date(),
			Tags: tags,
			Text: text,
			Data: data,
			StackTrace: stackTrace,
			LogLevel: logLevel,
		});
		this.postEntries();
	}

	postEntries = () => {
		if (this.entries.length > 0) this.outgoingEntries.push(this.entries.splice(0));

		while (this.outgoingEntries.length > 0) this.sendBatch(this.outgoingEntries.shift());
	};

	private sendBatch(batch: Array<LogEntry>) {
		const xmlhttp = new XMLHttpRequest();

		xmlhttp.onreadystatechange = (success) => {
			if (xmlhttp.readyState === XMLHttpRequest.DONE) {
				// if (xmlhttp.status !== 200) this.outgoingEntries.push(batch);
			}
		};
		xmlhttp.open('POST', `${environment.api.uri}/api/General/DeviceLog`, true);
		xmlhttp.setRequestHeader('X-TouchSessions', 'false');
		xmlhttp.setRequestHeader('Accept', 'application/json');
		xmlhttp.setRequestHeader('Content-Type', 'application/json');

		const sendData: DeviceLogInput = {
			VisitId: this.myVisitId,
			DeviceId: this.myDeviceId,
			ApiSessionToken: null,
			DeviceInfo: this.deviceInfoModel,
			Entries: batch,
		};
		xmlhttp.send(JSON.stringify(sendData));
	}
}
